/**
 * Created by Jie Gao on 19/09/18.
 */

import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {BonusBunniesGameConfig} from "../BonusBunniesGameConfig";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {BonusBunniesParsedInitData} from "../server/data/BonusBunniesParsedInitData";
import {BonusBunniesGameMode} from "../gamemode/BonusBunniesGameMode";

export class BonusBunniesLogo extends BaseView {

    public static bonusBunniesLogo:BonusBunniesLogo;

    private _layer:ScalableLayer;
    private _logoContainer:PIXI.Container;
    private _logoImage:PIXI.Sprite;
    private _landscapePosition:PIXI.Point = new PIXI.Point(-110, 56);
    private _portraitPosition:PIXI.Point = new PIXI.Point(360, 34);

    constructor() {
        super();
        this._logoContainer = new PIXI.Container();
        this._layer = StageManager.getLayer(BonusBunniesGameConfig.instance.LAYERS.LOGO.name);
        BonusBunniesLogo.bonusBunniesLogo = this;
        this.addFeatureEventHandlers();
    }

    private addFeatureEventHandlers():void {
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onInitDataParsed(event.params[0]));
    }

    private onInitDataParsed(data:BonusBunniesParsedInitData):void {
        if (data.mode == BonusBunniesGameMode.BONUS_GAME || data.nextMode == BonusBunniesGameMode.BONUS_GAME){
            this.disableLogo();
        }
    }

    protected initAnimations():void {
        this.addChild(this._logoContainer);
        this._layer.addChild(this);

        this._logoImage = new PIXI.Sprite(GameResources.getTextures("logo/logo")[0]);
        this._logoImage.anchor.set(0.5, 0.5);
        this._logoImage.position.y = -10;
        this._logoContainer.addChild(this._logoImage);
    }

    protected onResize(resizeData:IResizeData):void {
        if(this._resizeData.orientation == Orientation.LANDSCAPE) {
            //Calculate logo space to the left
            const leftSpace:number = (resizeData.width - 720) / 2;
            this._logoImage.scale.set(0.44, 0.44);
            if((leftSpace - 58) > this._logoImage.width) {
                this._logoImage.visible = true;
                this._logoContainer.position = this._landscapePosition;
            } else {
                this._logoImage.visible = false;
            }
        } else {
            //Calculate logo top space
            const topSpace:number = (resizeData.height - 720) / 2;
            if((topSpace + 80) > this._logoImage.height) {
                this._logoImage.scale.set(1, 1);
                this._logoImage.visible = true;
                this._logoContainer.position = this._portraitPosition;
            } else {
                this._logoImage.visible = false;
            }
        }
    }

    public enableLogo():void {
        this._logoContainer.visible = true;
    }

    public disableLogo():void {
        this._logoContainer.visible = false;
    }
}